import React from 'react';
import DropDownBox from 'devextreme-react/drop-down-box';
import TreeView from 'devextreme-react/tree-view';
import CustomStore from 'devextreme/data/custom_store';
import 'whatwg-fetch';
import { QUERY_GET_TAXONOMIESTREE } from "./../../fetch/constantQueries";
import { getUrl } from '../../fetch/basicThunk';
import { Template } from 'devextreme-react';
import { renderDropdownIcon } from '../../commonFunctions/commonFunctions';
import { useTranslation, withTranslation } from 'react-i18next';

//export default class TreeSelector extends React.Component {
class TreeSelector extends React.Component {
  constructor(props) {
    super(props);
    this.treeView = null;
    this.dropDownBox = null;
    this.treeDataSource = this.makeAsyncDataSource('treeProducts.json');
    this.treeView_itemSelectionChanged = this.treeView_itemSelectionChanged.bind(this);
    this.syncTreeViewSelection = this.syncTreeViewSelection.bind(this);
    this.treeViewRender = this.treeViewRender.bind(this);
    this.resetValue = this.resetValue.bind(this);
  }
  
  makeAsyncDataSource(jsonFile) {
    const token = localStorage.getItem("apoloCRM_Token");
    const bearer = "Bearer "+token;
    let queryString = QUERY_GET_TAXONOMIESTREE;
    if(this.props.services)
      {
        const serviceIds = this.props.services.join(",");
        queryString = queryString.concat("?serviceIds=", serviceIds)
      }
    const fetchConfig = {
      headers: {
      'Accept': "application/json",
      "Content-Type": "application/json",
      Authorization: bearer
      },
      method: 'GET',
    };
    return new CustomStore({
      loadMode: 'raw',
      key: 'ID',
      load: function() {
        return fetch(getUrl()+ queryString,fetchConfig)
          .then(response => response.json());
      }
    });
  }

  componentDidUpdate(prevprops){
    if(prevprops.services !== this.props.services){
       const store = this.makeAsyncDataSource()
       this.treeDataSource = store;    
    }
  }

  resetValue() {
    this.syncTreeViewSelection({value:[]})
  }

  render() {
    return (
      <div>
        <DropDownBox
          ref={(ref) => {if (ref) {ref.instance.reset = this.resetValue}}}
          value={this.props.taxonomies}
          valueExpr="key"
          deferRendering={false}
          displayExpr="value"
          label={this.props.t("Taxonomy")}
          labelMode='floating'
          placeholder={this.props.t("Taxonomy")}
          showClearButton={true}
          dataSource={this.treeDataSource}
          // onValueChanged={this.syncTreeViewSelection}
          onOpened={this.syncTreeViewSelection}
          contentRender={this.treeViewRender}
          showDropDownButton
          dropDownButtonTemplate={"dropdownButton"}
        >
          <Template
                     name="dropdownButton"
                     render={renderDropdownIcon}
          />
      </DropDownBox>
      </div>
    );
  }

  treeViewRender() {
    return (
      <TreeView 
        dataSource={this.treeDataSource}
        ref={(ref) => this.treeView = ref}
        dataStructure="plain"
        keyExpr="key"
        parentIdExpr="parentKey"
        selectionMode="multiple"
        showCheckBoxesMode="normal"
        selectNodesRecursive={this.props.selectNodesRecursive}
        displayExpr="value"
        selectByClick={true}
        onItemSelectionChanged={this.treeView_itemSelectionChanged}
      />
    );
  }

  syncTreeViewSelection(e) {
    let treeView = (e.component && e.component.selectItem) || (this.treeView && this.treeView.instance);

    if (treeView) {
      if (e.value === null || (e.value && e.value.length === 0) || !this.props.taxonomies) {
        treeView.unselectAll();
      } else {
        let values = e.value || this.props.taxonomies;
        values && values.forEach(function(value) {
          treeView.selectItem(value);
        });
      }
    }

    if (e.value !== undefined) {
      this.props.onSelectionChanged(e.value);
    }
  }

  treeView_itemSelectionChanged(e) {
    this.props.onSelectionChanged(e.component.getSelectedNodeKeys());
  }
}

export default withTranslation()(TreeSelector)